import WebStorage, { storageTypes } from '@/Utils/WebStorage';

function getStorage(key) {
    return new WebStorage(key, storageTypes.localStorage);
}

function add(key, value) {
    const storage = getStorage(key);
    storage.set(value);
}

function get(key) {
    const storage = getStorage(key);
    return storage.get();
}

function remove(key) {
    const storage = getStorage(key);
    storage.remove();
}

function set(key, value) {
    const storage = getStorage(key);
    storage.set(value);
}

export const commonWebStorage = {
    add,
    get,
    remove,
    set,
};